import * as React from 'react';
import { AnimationElement } from '../../../common/Animation';
import * as styles from './PromotionSectionHeaderLayout.css';
import { subheaderAnimationConfig } from '../../constants';

interface IPromotionSectionHeaderLayoutProps {
  header: React.ReactNode;
  mobile: boolean;
  subheader: React.ReactNode;
}

export const PromotionSectionHeaderLayout = ({ mobile, subheader, header }: IPromotionSectionHeaderLayoutProps) => {
  return (
    <div>
      <AnimationElement layout="position">{header}</AnimationElement>

      {!mobile && (
        <AnimationElement layout="position" className={styles.subheader} {...subheaderAnimationConfig}>
          {subheader}
        </AnimationElement>
      )}
    </div>
  );
};
